const generateGradient = (values) => {
    const { color_stops: colorStops, direction } = values;
    const colorsArray = colorStops.map((color) => {
        const { rgba: rgbaArray, stop_position: stopPosition } = color;
        const rgba = rgbaArray.join(',');
        return `rgba(${rgba}) ${stopPosition}`;
    });
    return `linear-gradient(${direction}, ${colorsArray.join(',')})`;
};

export const parseColors = (swatchId, colorName, colorSwatches) => {
    const {
        hex_code: hexCode,
        is_light: isLight,
        gradient
    } = colorSwatches?.[swatchId] ?? {};

    return {
        value: gradient ? generateGradient(gradient) : hexCode,
        name: colorName,
        hasBorder: isLight
    };
};
